import imgUtil from 'blueimp-load-image';

function imageScale({file, width, height, type, success, error }){
	if(!height) height = width;
	
	if(!type) type == file.type || 'image/jpeg';
	
	let image = new Image();
	image.src = file.path || URL.createObjectURL(file);
	image.onload = ()=>{
		let w = image.width;
		let h = image.height;
		
		URL.revokeObjectURL(image.src);
		image.src 			= null;
		image				= null;
		
		if(w<=width && h<=height){
			file.originWidth	= w;
			file.originHeight	= h;
			file.width			= w;
			file.height			= h;
			success(file);
		} else {
			imgUtil(file, {
				maxWidth	: width, 
				maxHeight	: height, 
				canvas		: true,
			}).then(img=>{
				img.image.toBlob(blob=>{
					let data = new File([blob], "avatar.jpg", { type });
					data.width			= img.image.width;
					data.height			= img.image.height;
					data.originWidth	= w;
					data.originHeight	= h;
					success(data);
				}, type, 0.92);
			});
		} 
	}
	
}

function thumb(url, width, height){
	if(!width) width	= 100;
	if(!height) height	= width;
	
	return url + '?x-image-process=image/resize,w_'+width+',h_'+height+'/quality,q_85';
}

export default {
	thumb,
	imageScale,
};